module.exports = __webpack_public_path__ + "img/d6edd48a95b1a737f127655b141f4c4d.png";